import { studentMessagesEN } from './lib/intl/en-US';

export const programId = '5f170d41b36f61575ceed6cb';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },

    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': studentMessagesEN,
    },
};

